import { getRideFilters } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toFiltersFetchers = function toFiltersFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetFilters: toFetcher(function (params, _) {
      return "GetFilters".concat(params.browseCategory);
    }, function (req, opt) {
      return unwrap(function () {
        return getRideFilters(api, 'on_demand', undefined, req.browseCategory, req.pelotonPlatform, opt.includeIconImages ? 'true' : 'false');
      });
    })
  };
};